module.exports = __webpack_public_path__ + "img/hangup.b7682199.svg";